export const favoritesStore = {
  hasChange: 0,
  spId: '',
  isFavoritesTab: false,
};

export function updateFavorites(spId: string) {
  favoritesStore.hasChange += 1;
  favoritesStore.spId = spId;
}


